/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {IssueInterface, IssueTitleType} from '@/store/modules/issues/types';

/**
 * IssueTitleInfo Component
 *
 * @author jgeorgiadou@frontier.co.uk
 */
@Component({
    name: 'c-issue-title-info',
})
export default class IssueTitleInfo extends Vue {
    @Prop(Object) private issue!: IssueInterface;
    @Prop(Number) private type!: number;
    @Prop(String) private heading!: string;

    private currentUrl: string = '';

    /**
     * Mounted lifecycle event.
     */
    public mounted(): void {
        if (this.$router.currentRoute.name) {
            this.currentUrl = this.$router.currentRoute.name;
        }
    }

    /**
     * @return {boolean}
     */
    get titleType(): boolean {
        return IssueTitleType.TITLE === this.type;
    }

    /**
     * @return {boolean}
     */
    get formType(): boolean {
        return IssueTitleType.FORM === this.type;
    }

    /**
     * Open the related issues in new windows
     * @param id
     */
    public openNewWindow(id: string): void {
        window.open('/issue-detail/' + id);
    }
}
